import $ from 'jquery';

$(document).ready(function () {
    $('.titreCollapse, a[role=tab], .detailPrixCollapse').click(function (event) {
        if (event.which == 2) {
            event.preventDefault();
        }
    });
});
